import React from 'react';
import Table from '@tphglobal/components/table';
import { useDispatch } from 'react-redux';
import { FixedTitle } from '@tphglobal/common/utils';
import { brand } from '@tphglobal/common/theme/style.palette';
import { Modal } from '@tphglobal/components';
import { usePopupReducer } from '@tphglobal/common/hooks';
import { StyledHeading } from './styles';
import messages from '../../messages';
import Creating from './creating';

const guideLinks: Record<string, string> = {
  'Getting Started with Freelance Portal':
    'https://tphglobal.atlassian.net/wiki/spaces/TPHCS/pages/1708490865/Getting+Started+-+Freelance+Portal',
  'Fetching a Company':
    'https://tphglobal.atlassian.net/wiki/spaces/TPHCS/pages/1708097644/Setup+Company+by+Fetching+your+Company+ID',
  'Creating a Timecard':
    'https://tphglobal.atlassian.net/wiki/spaces/TPHCS/pages/1708687547/Insert+Timecard',
  'Adding in a Split Shift':
    'https://tphglobal.atlassian.net/wiki/spaces/TPHCS/pages/2150006973/Adding+in+a+Split+Shift',
  'How to resubmit a Timecard':
    'https://tphglobal.atlassian.net/wiki/spaces/TPHCS/pages/1878622391/How+to+Resubmit+a+Timecard',
  'Changing your Droplist minutes step':
    'https://tphglobal.atlassian.net/wiki/spaces/TPHCS/pages/1765081100/Change+your+Minutes+Step+and+Time+Options+for+your+Timecard+entry',
};

const Guides = () => {
  return (
    <Table
      data={[
        {
          guideTitle: (
            <FixedTitle
              varient="Fixed12Regular"
              color={brand?.secondaryMain}
              style={{
                cursor: 'pointer',
                textDecoration: 'underline',
                textUnderlineOffset: '2px',
                paddingLeft: '24px',
                fontSize: '14px',
              }}
              onClick={() =>
                window.open(
                  guideLinks['Getting Started with Freelance Portal'],
                  '_blank'
                )
              }
            >
              Getting Started with Freelance Portal
            </FixedTitle>
          ),
        },
        {
          guideTitle: (
            <FixedTitle
              varient="Fixed12Regular"
              color={brand?.secondaryMain}
              style={{
                cursor: 'pointer',
                textDecoration: 'underline',
                textUnderlineOffset: '2px',
                paddingLeft: '24px',
                fontSize: '14px',
              }}
              onClick={() =>
                window.open(guideLinks['Fetching a Company'], '_blank')
              }
            >
              Fetching a Company
            </FixedTitle>
          ),
        },
        {
          guideTitle: (
            <FixedTitle
              varient="Fixed12Regular"
              color={brand?.secondaryMain}
              style={{
                cursor: 'pointer',
                textDecoration: 'underline',
                textUnderlineOffset: '2px',
                paddingLeft: '24px',
                fontSize: '14px',
              }}
              onClick={() =>
                window.open(guideLinks['Creating a Timecard'], '_blank')
              }
            >
              Creating a Timecard
            </FixedTitle>
          ),
        },
        {
          guideTitle: (
            <FixedTitle
              varient="Fixed12Regular"
              color={brand?.secondaryMain}
              style={{
                cursor: 'pointer',
                textDecoration: 'underline',
                textUnderlineOffset: '2px',
                paddingLeft: '24px',
                fontSize: '14px',
              }}
              onClick={() =>
                window.open(guideLinks['Adding in a Split Shift'], '_blank')
              }
            >
              Adding in a Split Shift
            </FixedTitle>
          ),
        },
        {
          guideTitle: (
            <FixedTitle
              varient="Fixed12Regular"
              color={brand?.secondaryMain}
              style={{
                cursor: 'pointer',
                textDecoration: 'underline',
                textUnderlineOffset: '2px',
                paddingLeft: '24px',
                fontSize: '14px',
              }}
              onClick={() =>
                window.open(
                  guideLinks['How to resubmit a Timecard'],
                  '_blank'
                )
              }
            >
              How to resubmit a Timecard
            </FixedTitle>
          ),
        },
        {
          guideTitle: (
            <FixedTitle
              varient="Fixed12Regular"
              color={brand?.secondaryMain}
              style={{
                cursor: 'pointer',
                textDecoration: 'underline',
                textUnderlineOffset: '2px',
                paddingLeft: '24px',
                fontSize: '14px',
              }}
              onClick={() =>
                window.open(
                  guideLinks['Changing your Droplist minutes step'],
                  '_blank'
                )
              }
            >
              Changing your Droplist minutes step
            </FixedTitle>
          ),
        },
      ]}
      specs={[
        {
          id: 'guideTitle',
          label: messages?.support?.table?.guideTitle,
        },
      ]}
    />
  );
};

export default Guides;
